import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";

import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles(theme => ({
  absolute: {
    position: "fixed",
    bottom: theme.spacing(3),
    right: theme.spacing(8)
  }
}));

export default function SimpleTooltips(props) {
  const { setOpen } = props;
  const classes = useStyles();
  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <React.Fragment>
      <Tooltip title="Add" aria-label="add">
        <Fab
          color="secondary"
          className={classes.absolute}
          style={{ zIndex: 1 }}
          onClick={handleOpen}
        >
          <AddIcon />
        </Fab>
      </Tooltip>
    </React.Fragment>
  );
}
